import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { api } from "../../../../app/applicationSlice";
import { RootState, RootThunk } from "../../../../app/store";
import { LoadingState } from "../../../../models/common";
import { emptyOf, Pagination } from "../../../../models/pagination";
import { fromJson, piTest } from "../../../../models/pitest";
import * as service from "../../../../services/pitest";
import { pitestQueryParams } from "../../../../services/pitest";
interface PitestState {
  PitestData: [],
  Total: 0,

  Current: 1,
  peopleList: piTest[]
}

const initialState: PitestState = {
PitestData: [],
  Total: 0,
  Current: 1,

  peopleList:[],

};

const pitestSlice = createSlice({
  name: "pitestSlice",
  initialState,
  reducers: {
   
    setData(state, action) {
      state.PitestData = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
    setpeopleList: (state, action) => {
      state.peopleList = action.payload;
    },
   

  },
});

export const {  setData, 
  setTotal,
  setCurrent,setpeopleList } = pitestSlice.actions;

  export const selectPitestData = (state: RootState) => state.pitest.PitestData

  export const selectTotal = (state: RootState) => state.pitest.Total
  
  export const selectCurrent = (state: RootState) => state.pitest.Current
  
  

  export const selectPeopleList = (state: RootState) =>
  state.pitest.peopleList;


export function getPitestList(params: pitestQueryParams): RootThunk {
  return api(service.getPitestList(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
    dispatch(setTotal(data.total))
  });
}

export function getpeopleList(
  size ?: any
): RootThunk { 
  return api(service.getPeopleList(size) ,(data: any, dispatch) => {
    const list = data.records
    dispatch(setpeopleList(list));       
  });
}



export default pitestSlice.reducer;
